var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.title)?_c('div',{staticClass:"theme-icon",attrs:{"theme-icon-title":_setup.title['icon_title_' + _setup.theme]}},[_c('inline-svg',{attrs:{"src":require(`../../../assets/icons/header/theme/${_setup.theme}.svg`)},on:{"click":function($event){return _setup.updateTheme()}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }